import { render, staticRenderFns } from "./CustomToken.vue?vue&type=template&id=607b9ad2&"
import script from "./CustomToken.vue?vue&type=script&lang=js&"
export * from "./CustomToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports